// Types
import * as Types from '../types'
import api from '../../../services/api'
import { callbackProps } from "../../../constants";
import { requestActionProps, requestGenerate } from "../../common";

const actionGetAvatars = (
  payload:any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.AVATAR_LIST),
  api: api.getAvatars,
  payload: { data: new URLSearchParams(payload) },
  callback,
});

export {
  actionGetAvatars
};